// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e42eddd2","732":"dfd6cb9c","977":"ae95dddc"}[chunkId] + ".chunk.js";
};